export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_TEKAY_fragment_2.d163b527.jpg";